import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GetReport, Status } from '../../services/apiTypes';
import { fetchReport as fetchReportAPI, ReportParam } from './api';
import { isGetReport } from '../../_utils/typeGuardUtils';

interface partsSelectionState {
  status: Status;
  report: GetReport;
}

const initialReport: GetReport = {
  rmaNo: '',
  serialNo: '',
  model: '',
  customerName: '',
  originalCustomer: '',
  inspector: '',
  qcInspector: '',
  inspectionDate: '1900-01-01',
  qcDate: '1900-01-01',
  isInspectionSerialChecked: false,
  isQcSerialChecked: false,
  documentNo: '',
  effectiveDate: '1900-01-01',
  inspectionResultList: [],
  qcResultList: [],
  markers: [],
  memo: '',
  filepaths: [],
};

const initialState: partsSelectionState = {
  status: 'idle',
  report: initialReport,
};

export const fetchReport = createAsyncThunk(
  'report/fetchReport',
  async (params: ReportParam, { rejectWithValue }) => {
    try {
      return await fetchReportAPI(params);
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    resetReport: (state) => {
      state.report = initialReport;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReport.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchReport.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (isGetReport(action.payload)) {
          state.report = action.payload;
        }
      })
      .addCase(fetchReport.rejected, (state) => {
        state.status = 'failed';
      });
  },
});
export const { resetReport } = reportSlice.actions;
export default reportSlice.reducer;
